export default "__VITE_ASSET__9594650c__"